import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "interactive-step" }
const _hoisted_2 = { class: "interactive-step-main" }
const _hoisted_3 = { class: "circle" }
const _hoisted_4 = {
  key: 0,
  class: "icon icon-checkmark"
}
const _hoisted_5 = { class: "text" }
const _hoisted_6 = {
  key: 0,
  class: "icon icon-checkmark"
}
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 0,
  class: "icon icon-checkmark"
}
const _hoisted_9 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.level === 1 || _ctx.level === 2)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('tutorial_instruction')), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["line-default1", {'line__level1': _ctx.level === 1 || _ctx.clearLevel1}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["default-circle", {'circle1': _ctx.level === 1 || _ctx.clearLevel1}])
      }, [
        (_ctx.clearLevel1)
          ? (_openBlock(), _createElementBlock("i", _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('tutorial-level1')), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["line-default2", {'line__level1__level2': _ctx.level === 1 || _ctx.clearLevel1, 'line__level2': _ctx.level === 2}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["default-circle", {'circle2': _ctx.level === 2}])
      }, [
        (_ctx.clearLevel2)
          ? (_openBlock(), _createElementBlock("i", _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('tutorial-level2')), 1)
      ], 2)
    ])
  ]))
}